import { environmentDefaults } from './environment-defaults';
import * as defaultsDeep from 'lodash.defaultsdeep';

const override = {
  baseUrl: 'https://pioneer3-service.dev.onyxcentersource.com',
  hostname: 'pioneer3.dev.onyxcentersource.com',
  portalUrl: 'https://portal.dev.onyxcentersource.com',
  onyxGPImagesCommonDataUrl: 'https://cdn.onyxcentersource.com/static/custom/gp',
  invoiceHistoryUrl: 'https://ooiv-invoice-history.dev.onyxcentersource.com',
  emailValidation: true,
  allowApiDocs: true,
  agencyDashboardUrl: 'https://agency-dashboard3.dev.onyxcentersource.com',
  showAgencyDashboard: false
};

export const environment = defaultsDeep(override, environmentDefaults);



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/environments/environment.dev3.ts